import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "attack_lateral",
  "use": "attack_lateral-usage",
  "viewBox": "0 0 18 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 15\" id=\"attack_lateral\"><g fill-rule=\"evenodd\"><path d=\"M1 0v2.98h1.91V.661L8.99 5.44 15.07.661V2.98h1.91V0zM2.91 10.29V7.96H1v3.1h4.94v1.877H4.003v1.117h9.979v-1.117h-1.938V11.06h4.936v-3.1h-1.91v2.33L8.99 5.48z\" /><path d=\"M3.91 3.98H0v2.98h3.91v1.27l3.5-2.76-3.5-2.75zM10.58 5.47l3.49 2.76V6.96h3.91V3.98h-3.91V2.72z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id